<label
  class="mat-focus-indicator mat-raised-button mat-button-base mat-primary"
  for="fileResponse"
>Anexar arquivo</label>
<input
  id="fileResponse"
  name="fileResponse"
  type="file"
  [accept]="mimeTypes"
  (change)="uploadFiles($event)"
  multiple
  hidden
>
